import React, { Component } from 'react';
import { Motion, spring, presets } from 'react-motion';
import { Utils } from '../../utils/Utils';

// let rangeSize = 50; //感应范围容错大小，越大越容易拖进框内

class MatchDraw extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mainSize: null,
            start_left: 0,  //初始左边距离
            start_top: 0,  //初始顶部距离
            start_pageX: 0,  //初始拖动左边距离
            start_pageY: 0,  //初始拖动顶部距离
            left: props.item.defaultPos.x || 0, //实时显示位置
            top: props.item.defaultPos.y || 0,     //实时显示位置
            selectNum: 0,   //拖对的次数
            dragState: 0,    //0-无操作；1-拖拽中；2-正确；3-拖错(done模板用)；
            dragRight: false,   //拖到了正确位置
            width: props.item.defaultWidth.width || 0,
            height: props.item.defaultWidth.height || 0,
            autoDisTipsDraw: props.autoDisTipsDraw, //支持点击选择成功的序号
            canMatch: true,
            startZIndex: window.zIndex,
            matchDoneElements: props.matchDoneElements || [],
            dragAnswers: props.dragAnswers || [],
            dragAnswerDsts: props.dragAnswerDsts || [],
            restoreOption: props.restoreOption || -1,
            gameDragDst: "",    //该元素所在的位置
        };
        /*定义两个值用来存放鼠标按下的地方距离元素上侧和左侧边界的值*/
        this.disX = 0;
        this.disY = 0;
        this.startMoveTime = 0; //用于记录录屏开始拖拽的时间点
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectNum: nextProps.drawRightTotal,
            autoDisTipsDraw: nextProps.autoDisTipsDraw,
            canMatch: nextProps.canMatch,
            matchDoneElements: nextProps.matchDoneElements,
            dragAnswers: nextProps.dragAnswers,
            dragAnswerDsts: nextProps.dragAnswerDsts,
            restoreOption: nextProps.restoreOption,
        }, () => {

        });
    }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        const { index, item, isDone, changeSelect } = this.props;
        const { left, top, selectNum, dragState, mainSize, restoreOption, gameDragDst } = this.state;
        if (isDone && restoreOption > -1 && restoreOption !== prevState.restoreOption) {
            let _gameDst = gameDragDst;
            let _left = left;
            let _top = top;

            if ((restoreOption === 1 && dragState === 3) || restoreOption === 2) {   //1-错误弹回原位   2-全部弹回原位
                _left = item.defaultPos.x;
                _top = item.defaultPos.y;
                if (changeSelect && typeof changeSelect === 'function') {
                    changeSelect((restoreOption === 2 ? 0 : selectNum), 0, index, (restoreOption === 2 ? "" : _gameDst), _left, _top, new Date().getTime());
                }
            } else if (restoreOption === 3) {   //到正确位置
                if (item.pos) {
                    _left = item.pos[0].x * mainSize.width;
                    _top = item.pos[0].y * mainSize.height;
                } else {
                    _left = item.defaultPos.x; //没有正确位置，回到原位
                    _top = item.defaultPos.y;
                }
            }
            that.setState({
                left: _left,
                top: _top
            });
        }

    }

    componentDidMount() {
        let content_size = {};
        let content_course = document.getElementById('content_course');
        content_size.width = content_course.clientWidth;
        content_size.height = content_course.clientHeight;
        this.setState({
            mainSize: content_size
        });
    }

    handleMouseDown(e) {
        const that = this;
        const { item } = this.props;
        const { left, top } = this.state;
        const event = e || window.event;
        event.preventDefault();
        event.stopPropagation();
        /*事件源对象兼容*/
        const target = event.target || event.srcElement;
        window.zIndex++;
        target.style.zIndex = window.zIndex;

        /*获取鼠标按下的地方距离元素左侧和上侧的距离*/
        this.disX = event.clientX - target.offsetLeft;
        this.disY = event.clientY - target.offsetTop;

        this.setState({
            start_left: left,
            start_top: top,
            start_pageX: event.pageX,
            start_pageY: event.pageY,
            width: item.bigImageSize && item.bigImageSize.width && item.bigImageSize.width / 2 > item.defaultWidth.width ? item.bigImageSize.width / 2 : item.defaultWidth.width,
            height: item.bigImageSize && item.bigImageSize.height && item.bigImageSize.width / 2 > item.defaultWidth.width ? item.bigImageSize.height / 2 : item.defaultWidth.height,
        });

        if (target.className.indexOf('drag_item') > -1) {
            /*定义鼠标移动事件*/
            document.onmousemove = this.fnMove.bind(this);
            /*定义鼠标抬起事件*/
            document.onmouseup = this.fnUp.bind(this);
        }

        that.startMoveTime = new Date().getTime();
    }

    fnMove(e) {
        const { start_left, start_top, start_pageX, start_pageY } = this.state;
        /*事件兼容*/
        const event = e || window.event;
        const ev = event.targetTouches ? event.targetTouches[0] || event.changedTouches[0] : event;    //触屏 ： 鼠标

        let _left = ev.pageX - start_pageX;
        let _top = ev.pageY - start_pageY;

        this.setState({
            left: start_left + _left,
            top: start_top + _top,
            dragState: 1
        });
    }

    fnUp(e) {
        const that = this;
        if (!e.targetTouches) {
            document.onmousemove = null;
            document.onmouseup = null;
        }

        const { index, item, changeSelect, isDone } = this.props;
        const { dragRight, left, top, selectNum, mainSize, autoDisTipsDraw, matchDoneElements, dragAnswers, dragAnswerDsts } = this.state;

        /*事件兼容*/
        const event = e || window.event;
        /*事件源对象兼容*/
        const target = event.target || event.srcElement;
        // const target = document.getElementById(item.bigImage);
        let _yes = selectNum;
        let _dragState = 0;
        let _left = 0;
        let _top = 0;
        let _width = item.defaultWidth.width;
        let _height = item.defaultWidth.height;
        let _gameDst = dragAnswerDsts && dragAnswerDsts[index] ? dragAnswerDsts[index] : autoDisTipsDraw;   //要传给changeSelect的位置名称，普通模板把当前拖的正确位置返回即可，done模板可能拖到错误的位置，因此需要传错误的位置

        let matchSizeHeight = item.matchSize ? item.matchSize.height : 0;    //匹配范围的2倍高度
        let matchSizeWidth = item.matchSize ? item.matchSize.width : 0;    //匹配范围的2倍宽度
        let bigImageHeight = item.bigImageSize ? item.bigImageSize.height : item.defaultWidth.height * 2;  //2倍图高
        let bigImageWidth = item.bigImageSize ? item.bigImageSize.width : item.defaultWidth.width * 2;
        let Points = [ // 拖动元素的4个点（四分之一点），上、右、下、左
            [(top + bigImageHeight / 8), (left + bigImageWidth / 8)], //bigImageSize是双倍图，取 1/4点需要除以8
            [(top + bigImageHeight / 8), (left + bigImageWidth / 8 * 3)], //bigImageSize是双倍图，取 3/4点需要除以8乘3
            [(top + bigImageHeight / 8 * 3), (left + bigImageWidth / 8 * 3)],
            [(top + bigImageHeight / 8 * 3), (left + bigImageWidth / 8)],
        ];
        let innerPolygonNum = 0;   // 拖动元素的4个1/4点同时有几个矩形里面，同时在多个矩形不能算对
        if (matchDoneElements && matchDoneElements.length) {
            // console.log("matchDoneElements", matchDoneElements)
            let allPolygon = [];
            for (let j = 0; j < matchDoneElements.length; j++) {
                let matchDoneElement = matchDoneElements[j];
                if (matchDoneElement.matchRange) {
                    let matchDoneElementHeight = matchDoneElement.matchRange.y * mainSize.height;    //匹配范围的顶点top
                    let matchDoneElementWidth = matchDoneElement.matchRange.x * mainSize.width;    //匹配范围的左点left
                    allPolygon.push([ // 匹配范围的矩形4个顶点，上、右、下、左
                        [matchDoneElementHeight, matchDoneElementWidth],
                        [matchDoneElementHeight, matchDoneElementWidth + matchSizeWidth / 2],
                        [matchDoneElementHeight + matchSizeHeight / 2, matchDoneElementWidth + matchSizeWidth / 2],
                        [matchDoneElementHeight + matchSizeHeight / 2, matchDoneElementWidth],
                    ]);
                }
            }
            allPolygon.every(Polygon => {
                Points.some(value => { return Utils.insidePolygon(value, Polygon) }) && innerPolygonNum++;
                return true;
            });
            console.log('innerPolygonNum', innerPolygonNum)
        }

        // target.style.zIndex = 199;
        if (target.className.indexOf('draged') > -1) {
            return false;
        } else if (target.className.indexOf('drag_item') > -1) {
            if (item.matchPos && item.matchPos.length) {
                for (let i = 0; i < item.matchPos.length; i++) {
                    let matchItem = item.matchPos[i];

                    let matchItemHeight = matchItem.y * mainSize.height;    //匹配范围的顶点top
                    let matchItemWidth = matchItem.x * mainSize.width;    //匹配范围的左点left
                    let polygon = [ // 匹配范围的矩形4个顶点，上、右、下、左
                        [matchItemHeight, matchItemWidth],
                        [matchItemHeight, matchItemWidth + matchSizeWidth / 2],
                        [matchItemHeight + matchSizeHeight / 2, matchItemWidth + matchSizeWidth / 2],
                        [matchItemHeight + matchSizeHeight / 2, matchItemWidth],
                    ];

                    if (
                        !(isDone && dragAnswers && dragAnswers[index] && dragAnswers[index] > -1) &&  //该位置已经有元素,done模板
                        !dragAnswerDsts.includes(item.gameDst[i]) &&  //不在已匹配的数组里面（多图匹配）
                        (
                            (item.gameDst.includes(autoDisTipsDraw)    //当前点击的图片是正确指引序号对应的图片
                                && item.defaultPos.x === left && item.defaultPos.y === top) //在原始的位置

                            || (matchItem &&
                                top > matchItemHeight - item.matchSize.height / 4 &&  // 图是双倍的，所以
                                top < (matchItemHeight + item.matchSize.height / 4) &&
                                left > matchItemWidth - item.matchSize.width / 4 &&   //左侧匹配范围 - 本身宽度的三分之一
                                left < (matchItemWidth + item.matchSize.width / 4/* - item.bigImageSize.width / 4*/)
                            )

                            || (Points.some(value => { return Utils.insidePolygon(value, polygon) }) && innerPolygonNum === 1)  // 至少有一个点在矩形里面，同时没有点在其他矩形里面
                        )
                    ) {  //计算范围

                        _left = item.pos[i].x * mainSize.width;
                        _top = item.pos[i].y * mainSize.height; //拖动后的垂直位置，这个是不变的。  dst-目标位置；matchRange-匹配位置
                        _width = item.bigImageSize.width / 2;
                        _height = item.bigImageSize.height / 2;
                        if (!dragRight) {
                            _yes++;
                            _dragState = 2;
                            // target.style.zIndex = 200;   //防止拖动到的底图做动画，zindex变高了覆盖 cid=2_3_1&page=7
                            that.setState({
                                dragRight: true,
                            });
                            _gameDst = item.gameDst[i];
                        }
                        break;  //拖对以后跳出
                    } else {
                        if (!isDone) {
                            _left = item.defaultPos.x;
                            _top = item.defaultPos.y;
                        }
                    }
                }
            } else {    //没有matchPos信息，也就是没有对应的正确答案
                if (isDone) { } else {
                    _left = item.defaultPos.x;
                    _top = item.defaultPos.y;
                }
            }
        } else {    //可能会碰到别的元素，e.target就变了，弹回原来位置
            _left = item.defaultPos.x;
            _top = item.defaultPos.y;
        }

        //done模板，支持拉下来、放在错误的位置
        if (isDone && _dragState !== 2) {   //没有拖对才走这个分支，防止拖对了再走，覆盖了对的
            let matchItemSize = item.matchSize;
            if (!matchItemSize && item.bigImage) {  //干扰项没有正确匹配位置，直接取元素宽高
                let bigImage = document.getElementById(item.bigImage);
                matchItemSize = {
                    width: parseInt(bigImage.style.width, 10) * 2,
                    height: parseInt(bigImage.style.height, 10) * 2,
                }
            }
            if (matchDoneElements && matchDoneElements.length) {
                for (let j = 0; j < matchDoneElements.length; j++) {
                    let matchDoneElement = matchDoneElements[j];

                    let polygon = [], matchDoneElementHeight = 0, matchDoneElementWidth = 0;
                    if (matchDoneElement.matchRange) {
                        matchDoneElementHeight = matchDoneElement.matchRange.y * mainSize.height;    //匹配范围的顶点top
                        matchDoneElementWidth = matchDoneElement.matchRange.x * mainSize.width;    //匹配范围的左点left
                        polygon = [ // 匹配范围的矩形4个顶点，上、右、下、左
                            [matchDoneElementHeight, matchDoneElementWidth],
                            [matchDoneElementHeight, matchDoneElementWidth + matchSizeWidth / 2],
                            [matchDoneElementHeight + matchSizeHeight / 2, matchDoneElementWidth + matchSizeWidth / 2],
                            [matchDoneElementHeight + matchSizeHeight / 2, matchDoneElementWidth],
                        ];
                    }

                    if (
                        !(dragAnswers && dragAnswers[j] && dragAnswers[j] > -1) &&  //拖放的位置已经有元素
                        dragAnswers[index] === -1 &&  //拖放的元素没有占用位置
                        !dragAnswerDsts.includes(matchDoneElement.gameDst) &&  //不在已匹配的数组里面
                        (
                            // !item.matchPos ||  //该项没有正确答案，也直接参与匹配

                            (matchDoneElement.gameDst === autoDisTipsDraw    //当前点击的图片是正确指引序号对应的图片
                                && item.defaultPos.x === left && item.defaultPos.y === top) //在原始的位置

                            || (matchDoneElement && matchDoneElement.matchRange &&
                                top > matchDoneElementHeight - matchItemSize.height / 4 &&
                                top < matchDoneElementHeight + matchItemSize.height / 4 &&
                                left > matchDoneElementWidth - matchItemSize.width / 4 &&   //左侧匹配范围 - 本身宽度的三分之一
                                left < matchDoneElementWidth + matchItemSize.width / 4)

                            || (Points.some(value => { return Utils.insidePolygon(value, polygon) }) && innerPolygonNum === 1)
                        )
                    ) {
                        if (matchDoneElement.pos) {
                            _left = matchDoneElement.pos.x * mainSize.width;
                            _top = matchDoneElement.pos.y * mainSize.height;
                        }
                        _width = item.bigImageSize ? item.bigImageSize.width / 2 : item.defaultWidth.width;
                        _height = item.bigImageSize ? item.bigImageSize.height / 2 : item.defaultWidth.height;
                        _dragState = 3;
                        _gameDst = matchDoneElement.gameDst;    //!item.matchPos ? `noDst${j}` : 
                        break;
                    } else {
                        _left = item.defaultPos.x;
                        _top = item.defaultPos.y;
                    }
                }
            }
            if (dragRight) {    //从正确的位置拖下来
                that.setState({
                    dragRight: false
                }, () => {
                    _yes--;
                    if (_dragState === 0) {
                        // _gameDst = item.gameDst[i];
                        _gameDst = dragAnswerDsts[index];
                    }
                });
            } else if (dragAnswers[index] === 0) {    //从错误的位置拖下来
                if (_dragState === 0) {
                    _gameDst = dragAnswerDsts[index];
                }
            }
        }

        this.setState({
            left: _left,
            top: _top,
            width: _width,
            height: _height,
            dragState: _dragState,
            gameDragDst: _gameDst,
        }, () => {
            if (changeSelect && typeof changeSelect === 'function') {
                changeSelect(_yes, _dragState, index, _gameDst, left, top, that.startMoveTime);
            }
        });

    }

    //兼容触屏版
    touchStartDot(e) {
        const that = this;
        const { item } = this.props;
        const { left, top } = this.state;
        let touch = e.targetTouches[0] || e.changedTouches[0];
        this.setState({
            start_left: left,
            start_top: top,
            start_pageX: touch.pageX,
            start_pageY: touch.pageY
        });
        window.zIndex++;
        document.getElementById(item.bigImage).style.zIndex = window.zIndex;

        that.startMoveTime = new Date().getTime();
    }

    render() {
        const that = this;
        const { item, total, isDone } = this.props;
        const { left, top, width, height, dragState, selectNum, canMatch, startZIndex } = this.state;
        return (
            <Motion style={{
                x: spring(left, presets.wobbly),
                y: spring(top, presets.wobbly)
            }}>
                {interpolatingStyle => {
                    return (
                        <div>
                            <img id={item.bigImage} alt="" src={window.resourceUrl + item.bigImage}
                                onMouseDown={((dragState !== 2 && selectNum < total) || isDone) && canMatch ? (e) => that.handleMouseDown(e) : null}
                                onTouchStart={((dragState !== 2 && selectNum < total) || isDone) && canMatch ? (e) => that.touchStartDot(e) : null}
                                onTouchMove={((dragState !== 2 && selectNum < total) || isDone) && canMatch ? (e) => that.fnMove(e) : null}
                                onTouchEnd={(e) => that.fnUp(e)}
                                // onMouseUp={dragState !== 2 ? (e) => that.fnUp(e) : null}
                                className={dragState === 1 ? "drag_item dragging" : dragState === 2 ? "drag_item draged" : "drag_item"}
                                style={{
                                    "position": "absolute",
                                    "left": 0,
                                    "top": 0,
                                    "width": width + 'px',
                                    "height": height + 'px',
                                    "marginTop": (dragState !== 2 ? (item.defaultWidth.height - height) / 2 : 0) + "px",
                                    "marginLeft": (dragState !== 2 ? (item.defaultWidth.width - width) / 2 : 0) + "px",
                                    "overflow": "hidden",
                                    "transform": `translate(${interpolatingStyle.x}px, ${interpolatingStyle.y}px)`,
                                    "zIndex": startZIndex
                                }} />
                        </div>
                    )
                }}
            </Motion>
        );
    }
}

export default MatchDraw;



// WEBPACK FOOTER //
// ./src/components/on/MatchDraw.js